import { footerColumns } from '@/mocks/home';

const columnAnchors = ['#rank', '#collection', '#topic', '#trust'];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-primary-950">
                热
              </span>
              <span className="font-heading text-xl font-bold text-primary-50">热点黑料</span>
            </div>
            <p className="mt-5 max-w-sm text-[13px] leading-7 text-primary-100/70">
              每日更新的热点黑料榜单，TOP10 排行、全网合集、最全整理。把近期热点人物与事件的公开信息，
              按时间线整理成可以直接查阅的条目。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="flex items-center gap-2 rounded-full border border-primary-50/20 px-3.5 py-1.5 text-xs text-primary-100/80">
                <i className="ri-refresh-line flex h-3.5 w-3.5 items-center justify-center text-sm" />
                每日 09:00 / 21:00 更新
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-4 lg:col-span-8">
            {footerColumns.map((column, columnIndex) => (
              <div key={column.title}>
                <h3 className="font-heading text-sm font-bold text-primary-50">{column.title}</h3>
                <ul className="mt-4 flex flex-col gap-3">
                  {column.links.map((link) => (
                    <li key={link}>
                      <a
                        href={columnAnchors[columnIndex]}
                        className="text-[13px] text-primary-100/70 transition-colors hover:text-accent-400"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 border-t border-primary-50/20 pt-6">
          <p className="text-xs leading-6 text-primary-100/60">
            免责声明：本站内容均为公开渠道信息的聚合与时间线整理，仅用于信息查阅与交流，不对任何个人或机构作出事实认定与评价，也不构成任何形式的建议。如条目信息存在滞后或偏差，欢迎通过投稿入口反馈。
          </p>
          <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-primary-100/60">© 2026 热点黑料 · 保留所有权利</p>
            <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
              <a href="#trust" className="text-xs text-primary-100/70 transition-colors hover:text-accent-400">
                更新说明
              </a>
              <a href="#submit" className="text-xs text-primary-100/70 transition-colors hover:text-accent-400">
                纠错反馈
              </a>
              <a href="#submit" className="text-xs text-primary-100/70 transition-colors hover:text-accent-400">
                投稿须知
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}